'use client'

import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

import { useProductVolumePricingContext } from '../ProductVolumePricingContext'

import { ProductVolumePricingModalNotification } from './ProductVolumePricingModalNotification'
import { ProductVolumePricingModalTable } from './ProductVolumePricingModalTable'

export const ProductVolumePricingModal: FC = () => {
  const { openableControls } = useProductVolumePricingContext()

  return (
    <Dialog
      onClose={openableControls.handleClose}
      open={openableControls.isOpen}
    >
      <DialogTitle onClose={openableControls.handleClose}>
        <FormattedMessage id="volumePricing.modal.title" />
      </DialogTitle>
      <DialogContent>
        <div
          // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
          className="max-w-[640px]"
        >
          <ProductVolumePricingModalNotification />
          <ProductVolumePricingModalTable />
        </div>
      </DialogContent>
    </Dialog>
  )
}
